import { render } from "./DataBlockList.vue?vue&type=template&id=7db78454&scoped=true"
import script from "./DataBlockList.vue?vue&type=script&lang=js"
export * from "./DataBlockList.vue?vue&type=script&lang=js"

import "./DataBlockList.vue?vue&type=style&index=0&id=7db78454&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db78454"]])

export default __exports__